// TBD: come up better name. What is the braintree card? Is it provider or another super service?
var BraintreeCard = (function (BraintreeCardAbstract, CheckoutSettings) {

    var BraintreeCard = BraintreeCardAbstract.extend({

        paymentOption: CheckoutSettings.PaymentOption.BrainTree,

        complete: function (method) {
            var transactionData = {
                paymentType: 'braintree',
                selectedPaymentOption: this.paymentOption,
                paymentNonce: method.Nonce || '',
                paymentToken: method.Token || '',
                deviceData: this.braintree.kount.getDeviceData() || ''
            };

            this._logger && this._logger('braintree');

            return this._createPaymentTransaction(transactionData, { wait: true, preventDoubleRequests: true, hideErrors: this.hideErrors });
		}
	});

	return BraintreeCard;
})(BraintreeCardAbstract, CheckoutSettings);